<mbs-modal
  class="mbs-rd-enable"
  [title]="'shared:computers.enableConnect.titleProvider' | i18next: { format: 'title' }">
  <ng-container modal-body>
    <p>
      {{ 'shared:computers.enableConnect.firstProviderText' | i18next }}
      <br />
      <a
        [helpLink]="'/remote-management/connect/enable-ra'"
        target="_blank">
        {{ 'shared:computers.enableConnect.providerTextLink' | i18next }}
      </a>
    </p>
    <mbs-checkbox
      [label]="'shared:computers.enableConnect.agreeEnable' | i18next"
      [formControl]="checkbox"></mbs-checkbox>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      (click)="handleSubmit()"
      [loading]="loading$ | async"
      [disabled]="!checkbox.value"
      [type]="'primary'">
      {{ 'shared:buttons.enable' | i18next }}
    </mbs-button>
    <mbs-button (click)="baseModal.close()">{{ 'shared:buttons.cancel' | i18next }}</mbs-button>
  </ng-container>
</mbs-modal>
